export class LoadFormatEvents {
  static readonly type = '[LoadFormatEvents] Load Format Events';

  constructor(readonly formatSlug: string, readonly segmentId: string | null) {}
}
